import { Box, Container, Typography, Grid, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { motion } from 'framer-motion';

const industries = [
  'Warehousing & logistics operations',
  'Manufacturing units & factories',
  'Retail & e-commerce storage',
  'FMCG & food distribution',
  'Pharma & healthcare storage',
  'Cold storage facilities',
  'Spare parts & service businesses',
  'SMEs & growing enterprises',
];

export default function HomeIndustries() {
  return (
    <Box
      id="industries"
      className="circuit-bg"
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: '#fcfcfc',
        borderTop: '1px solid rgba(0,0,0,0.05)',
        overflowX: 'hidden',
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="overline"
            sx={{ color: '#ff6a00', fontWeight: 900, letterSpacing: 3, display: 'block', mb: 1 }}
          >
            Industries served
          </Typography>
          <Typography variant="h3" sx={{ fontWeight: 800, mb: 2, color: '#1a1a1a', lineHeight: 1.15, fontSize: { xs: '1.65rem', sm: '2rem', md: '3rem' } }}>
            Designed for Any Business That Needs More Space
          </Typography>
          <Typography
            sx={{
              color: '#555',
              maxWidth: 720,
              mb: 4,
              fontSize: '1.05rem',
              lineHeight: 1.75,
            }}
          >
            Our pallet racking systems are designed to maximize vertical storage, improve organization,
            and unlock unused capacity within your existing space. Whether you&apos;re storing lightweight
            goods or heavy industrial loads, the goal remains the same — more storage, less clutter,
            better flow.
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: '#1a1a1a' }}>
            Industries We Commonly Support:
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={10}>
              <List dense disablePadding>
                {industries.map((label) => (
                  <ListItem key={label} sx={{ px: 0, py: 0.5 }} disableGutters>
                    <ListItemIcon sx={{ minWidth: 28 }}>
                      <FiberManualRecordIcon sx={{ fontSize: 10, color: '#ff6a00' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={label}
                      primaryTypographyProps={{ variant: 'body1', sx: { color: '#444', fontWeight: 500 } }}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
